import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllVendorOrders } from "../../../Servicefile/ordermanagementservice.jsx";
import './fooduserorders.css'
const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px"
};
const filterSelectStylee = {

    color: "#000",
    border: "none",
    height: "35px",
    borderRadius: "4px"
};
const filterButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    height: '35px',
    borderRadius: "4px",
    padding: '0 15px'

};


const Foodvendororders = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const [data, setData] = useState([]);
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [week, setWeek] = useState('');
    const [day, setDay] = useState('');

    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const result = data.filter((item) =>
            item.vendorId?.toString().includes(searchTerm.toLowerCase()) ||
            item.userName?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(result);
    }, [searchTerm, data]);






    const handleExport = () => {

        if (filteredData.length === 0) {
            alert("There is no data to export based on the current filters.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = ["S.NO", "Order ID", "Date", "Time", "Category", "Type", "Name", "Payment", "Status", "Amount", "Feedback", "Ratings"];

        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.orderId || 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleDateString() : 'N/A',
            item.orderDateAndTime ? new Date(item.orderDateAndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A',
            item.category || 'N/A',
            item.service || 'N/A',
            item.userName || 'N/A',
            item.paymentMethod || 'N/A',
            item.status || 'N/A',
            item.grandTotal !== undefined ? Math.round(item.grandTotal) : 'N/A',

            item.feedback || 'N/A',
            item.ratings || 'N/A'
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    useEffect(() => {

        const fetchOrders = async () => {

            try {

                const token =
                    localStorage.getItem(
                        "authToken"
                    );

                const fetchedApiData =
                    await getAllVendorOrders(
                        token
                    );

                setData(
                    Array.isArray(
                        fetchedApiData
                    )
                        ? fetchedApiData
                        : []
                );

            } catch (err) {

                console.error(
                    "Fetching error:",
                    err
                );

                setData([]);

            }
        };

        fetchOrders();

    }, []);




    useEffect(() => {
        applyFilters();
    }, [year, month, week, day, data]);

    const applyFilters = () => {
        let filtered = Array.isArray(data) ? [...data] : [];

        if (year) {
            filtered = filtered.filter(item =>
                new Date(item.orderDateAndTime).getFullYear().toString() === year
            );
        }

        if (month) {
            const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month);
            if (monthIndex !== -1) {
                filtered = filtered.filter(item =>
                    new Date(item.orderDateAndTime).getMonth() === monthIndex
                );
            }
        }

        if (week) {
            const dayMap = { Sun: 0, Mon: 1, Tues: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
            const weekDayIndex = dayMap[week];
            if (weekDayIndex !== undefined) {
                filtered = filtered.filter(item =>
                    new Date(item.orderDateAndTime).getDay() === weekDayIndex
                );
            }
        }

        if (day === 'Yesterday') {
            const yesterdayStart = new Date();
            yesterdayStart.setDate(yesterdayStart.getDate() - 1);
            yesterdayStart.setHours(0, 0, 0, 0);
            const yesterdayEnd = new Date(yesterdayStart);
            yesterdayEnd.setHours(23, 59, 59, 999);
            filtered = filtered.filter(item => {
                const itemDate = new Date(item.orderDateAndTime);
                return itemDate >= yesterdayStart && itemDate <= yesterdayEnd;
            });
        } else if (day && day !== "") {
            if (day.match(/^\d{2}\/\d{2}\/\d{2}$/)) {
                const parts = day.split('/');
                const specificDateStart = new Date(`20${parts[2]}`, parseInt(parts[1]) - 1, parseInt(parts[0]));
                specificDateStart.setHours(0, 0, 0, 0);
                const specificDateEnd = new Date(specificDateStart);
                specificDateEnd.setHours(23, 59, 59, 999);
                filtered = filtered.filter(item => {
                    const itemDate = new Date(item.orderDateAndTime);
                    return itemDate >= specificDateStart && itemDate <= specificDateEnd;
                });
            }
        }
        setFilteredData(filtered);
    };

    const startYear = 2024;
    const endYear = new Date().getFullYear();
    const years = [];

    for (let y = startYear; y <= endYear; y++) {
        years.push(y);
    }


    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [days, setDays] = useState([]);

    useEffect(() => {
        const getDaysInMonth = (year, month) => {
            return new Date(year, month + 1, 0).getDate();
        };

        const totalDays = getDaysInMonth(selectedYear, selectedMonth);
        const daysArray = Array.from({ length: totalDays }, (_, i) => i + 1);
        setDays(daysArray);
    }, [selectedYear, selectedMonth]);


    useEffect(() => {
        if (year) {
            setSelectedYear(Number(year));
        } else {
            setSelectedYear(new Date().getFullYear());
        }
        if (month) {
            setSelectedMonth(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month));
        } else {
            setSelectedMonth(new Date().getMonth());
        }
    }, [year, month]);

    const tabContent = {
        Overview: (
            <div>

                <div
                    className="d-flex flex-wrap align-items-center mb-1 pt-3 rounded ps-0"
                    style={{ gap: "10px" }}
                >

                    <div style={{ flex: "0 0 auto" }}>
                        <select
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            className="form-select form-select-sm"
                            style={filterSelectStyle}
                        >
                            <option value="">Yearly</option>
                            {years.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div style={{ flex: "0 0 auto" }}>
                        <select
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            className="form-select form-select-sm"
                            style={filterSelectStyle}
                        >
                            <option value="">Monthly</option>
                            {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((m) => (
                                <option key={m} value={m}>
                                    {m}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div style={{ flex: "0 0 auto" }}>
                        <select
                            value={week}
                            onChange={(e) => setWeek(e.target.value)}
                            className="form-select form-select-sm"
                            style={filterSelectStyle}
                        >
                            <option value="">Weekly</option>
                            {["Sun", "Mon", "Tues", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                                <option key={d} value={d}>
                                    {d}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div style={{ flex: "0 0 auto" }}>
                        <select
                            value={day}
                            onChange={(e) => setDay(e.target.value)}
                            className="form-select form-select-sm"
                            style={filterSelectStyle}
                        >
                            <option value="">Date</option>
                            {days.map((day) => (
                                <option key={day} value={day}>
                                    {day.toString().padStart(2, "0")}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div style={{ flex: "0 0 auto" }}>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by ID / Name"
                            className="form-control form-control-sm"
                            style={{
                                ...filterSelectStylee,            // re‑use your select’s style
                                minWidth: 160,                   // slightly wider than a select
                                padding: "4px 8px",
                            }}
                        />
                    </div>


                    <div className='pe-2' style={{ marginLeft: "auto" }}>
                        <button
                            type="button"
                            className="btn btn-sm fw-bold"
                            style={filterButtonStyle}
                            onClick={handleExport}
                        >
                            Export
                        </button>
                    </div>
                </div>

                <div className="table-responsive rr pe-2">
                    <table
                        className="table-striped table-bordered align-middle"
                        style={{ fontSize: "0.95rem", width: "100%" }}
                    >
                        <thead>
                            <tr>
                                {/* <th style={tableHeaderStyle}>S.No</th> */}
                                <th style={tableHeaderStyle}>VendorID</th>
                                <th style={tableHeaderStyle}>Location</th>
                                <th style={tableHeaderStyle}>OrderID</th>
                                <th style={tableHeaderStyle}>Date</th>
                                <th style={tableHeaderStyle}>Time</th>
                                <th style={tableHeaderStyle}>Category</th>
                                <th style={tableHeaderStyle}>Type</th>
                                <th style={tableHeaderStyle}>Name</th>
                                <th style={tableHeaderStyle}>Payment</th>
                                <th style={tableHeaderStyle}>Status</th>
                                <th style={tableHeaderStyle}>Amount</th>
                                <th style={tableHeaderStyle}>Feedback</th>
                                <th style={tableHeaderStyle}>Ratings</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.length ? (
                                filteredData.map((item, index) => (
                                    <tr
                                        key={item.orderId || index}
                                        style={{
                                            backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                                        }}
                                    >
                                        {/* <td style={tableCellStyle}>{index + 1}</td> */}
                                        <td style={tableCellStyle}>#{item.vendorId || "N/A"}</td>
                                        <td style={tableCellStyle}>#{item.location || "N/A"}</td>
                                        <td style={tableCellStyle}>{item.orderId || "N/A"}</td>
                                        <td style={tableCellStyle}>
                                            {item.orderDateAndTime
                                                ? new Date(item.orderDateAndTime).toLocaleDateString()
                                                : "N/A"}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {item.orderDateAndTime
                                                ? new Date(item.orderDateAndTime).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })
                                                : "N/A"}
                                        </td>
                                        <td style={tableCellStyle}>{item.appType || "N/A"}</td>
                                        <td style={tableCellStyle}>{item.orderType || "N/A"}</td>
                                        <td style={tableCellStyle}>{item.userName || "-"}</td>
                                        <td style={tableCellStyle}>{item.paymentMethod || "N/A"}</td>
                                        <td style={tableCellStyle}>{item.status || "N/A"}</td>
                                        <td style={tableCellStyle}>
                                            ₹
                                            {item.grandTotal !== undefined ? Math.round(item.grandTotal) : "N/A"}
                                        </td>
                                        <td style={tableCellStyle}>{item.feedback || "-"}</td>
                                        <td style={tableCellStyle}>
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <span
                                                    key={star}
                                                    style={{
                                                        color:
                                                            item.ratings && Number(item.ratings) >= star
                                                                ? "#FFD700"
                                                                : "#e4e5e9",
                                                        fontSize: 18,
                                                        marginRight: 2,
                                                    }}
                                                >
                                                    ★
                                                </span>
                                            ))}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ ...tableCellStyle, fontStyle: "italic" }}>
                                        No data matches your filters.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        ),
    };

    return (
        <div>
            <div className="row" style={{ marginTop: '40px' }}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className='' style={{ overflowY: 'auto', height: 'calc(85vh - 40px)', marginTop: '-60px', scrollbarWidth: 'none' }}>
                        <p
                            className="breadcrumb maamaas-home-bredcum or7"
                            style={{
                                position: "fixed",
                                top: "80px",
                                left: "265px",
                                width: "100%",
                                backgroundColor: "#fff",
                                // zIndex: 1000,
                                padding: "10px 0",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/Homes"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>

                            <span className="separator"> &gt; </span>
                            <span
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Orders_Managment
                            </span>
                            <span className="separator"> &gt; </span>
                            <span
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </span>
                        </p>


                        <div style={{ marginTop: '20px', borderRadius: '8px' }}>
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: 6,
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: 6,
};

export default Foodvendororders;